import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { INavigation } from '@core/models';
import { MainNavigation } from '../main-navigation/main-navigation.component';
import { RouterModule } from '@angular/router';
import { CheckoutPopoverComponent } from '../checkout-popover/checkout-popover.component';
import { HeaderSearch } from '../header-search/header-search.component';
import { BottomSheet } from '../bottom-sheet/bottom-sheet.component';

/**
 * ### **MainHeader**
 *
 * Cabecera principal de la aplicacion: logo, buscador, menu de navegacion y acciones.
 *
 * En escritorio se despliega en una sola fila de cuatro columnas; en movil apila el
 * logo y el buscador, y el menu pasa a un {@link BottomSheet}. El alto que ocupa se
 * publica en el token `--header-height`, del que dependen `#content` y `#content-full`.
 */
@Component({
  selector: 'app-main-header',
  imports: [MainNavigation, RouterModule, CheckoutPopoverComponent, HeaderSearch, BottomSheet],
  templateUrl: './main-header.component.html',
  styleUrl: './main-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainHeader {
  /** Ancho del logo. Se conserva por compatibilidad con quien ya lo pasaba. */
  readonly width = input<string>('200px');

  /** Items del menu de navegacion. */
  readonly navigation = input<INavigation[]>([]);

  /** Logo de la marca, servido desde `public/`. */
  protected readonly image = 'img/logo.svg';

  /** Estado del panel de menu en movil. */
  protected readonly menuOpen = signal<boolean>(false);

  /** Abre el panel de menu. */
  protected openMenu(): void {
    this.menuOpen.set(true);
  }
}
